import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTree = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M15.5 12.75V12a2 2 0 0 0-2-2h-7a2 2 0 0 0-2 2v.75m5.5-5.5V10M7.451 4.986l2.064 2.063a.687.687 0 0 0 .97 0l2.064-2.064a.687.687 0 0 0 0-.97L10.486 1.95a.687.687 0 0 0-.972 0L7.451 4.014a.687.687 0 0 0 0 .971Zm-5.5 11 2.063 2.063a.687.687 0 0 0 .971 0l2.064-2.063a.687.687 0 0 0 0-.972l-2.064-2.063a.687.687 0 0 0-.97 0L1.95 15.014a.687.687 0 0 0 0 .972Zm11 0 2.063 2.063a.687.687 0 0 0 .972 0l2.063-2.063a.687.687 0 0 0 0-.972l-2.063-2.063a.687.687 0 0 0-.972 0l-2.063 2.063a.687.687 0 0 0 0 .972Z"
	})]
});
const ForwardRef = forwardRef(SvgTree);
export { ForwardRef as ReactComponent };
